import { useState, useEffect } from "react";

/**
 * Shared hook that tracks whether the viewport is at or below a breakpoint.
 * Uses `window.matchMedia` so it reacts to resize / orientation changes
 * without polling.
 *
 * @param {number} breakpoint  Max-width in pixels (default 768)
 * @returns {boolean} `true` when viewport width <= breakpoint
 */
export default function useNarrowViewport(breakpoint = 768) {
  const [isNarrow, setIsNarrow] = useState(
    () => window.matchMedia(`(max-width: ${breakpoint}px)`).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e) => setIsNarrow(e.matches);
    setIsNarrow(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [breakpoint]);

  return isNarrow;
}
